
import forEach from 'lodash/forEach';


let rtn = {},
	linkCollection = document.querySelectorAll('a.ext');

/**
* Function that tracks a click on an outbound link in Analytics.
* This function takes a valid URL string as an argument, and uses that URL string
* as the event label. Setting the transport method to 'beacon' lets the hit be sent
* using 'navigator.sendBeacon' in browser that support it.
*/
const trackOutboundLink = function(url) {
   ga('send', 'event', 'outbound', 'click', url, {
     'transport': 'beacon',
     'hitCallback': function(){
     	console.log(url);
     	//document.location = url;
     }
   });
}


const filterExternalLinks = () => {

	let res = [];
	//console.log(linkCollection);
	
	forEach(linkCollection, (l) => {
		l.addEventListener('click', (e) => {
			trackOutboundLink(l.href);
		})
	})

}


rtn.init = () => {

	filterExternalLinks();

}

module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/track-external-clicks.js